import axios from "axios";

const getSubscriptions = async (formdetails, page, records) => {
  const formdata = {
    filters: formdetails,
    page: page,
    records: records,
  };
  const response = await axios.post(
    "/api/subscription-membership/get-subscriptions",
    formdata
  );
  return response.data;
};

const cancelSubscription = async (id) => {
  try {
    const response = await axios.post(
      "/api/subscription-membership/cancel-subscription",
      { subscriptionId: id }
    );
    return response.data;
  } catch (error) {
    console.error("Error canceling subscription:", error);
    throw error;
  }
};
const changeStatus = async (id) => {
  try {
    const response = await axios.post(
      "/api/subscription-membership/change-status",
      { subscriptionId: id }
    );
    return response.data;
  } catch (error) {
    console.error("Error canceling subscription:", error);
    throw error;
  }
};

const getDetails = async (id) => {
  const response = await axios.get(
    `/api/subscription-membership/details/${id}`
  );
  return response.data;
};

const getAllPaymentGateways = async () => {
  const response = await axios.get(
    "/api/subscription-membership/get-payment-gateways"
  );
  return response.data;
};

const getAllPlanId = async() =>{
    const response = await axios.get('/api/subscription-membership/get-plan-id');
    console.log(response.data)
    return response.data;
}
export default {
  getSubscriptions,
  cancelSubscription,
  getAllPaymentGateways,
  getDetails,
  changeStatus,
  getAllPlanId,
};
